/**
 * Toto — CompanionProfile for the Rainbow Interests deployment.
 *
 * IDENTITY ONLY. This file describes who Toto is: name, wordmark, chat
 * strings, icon key, avatar renderer, terminology. It does NOT contain
 * Rainbow-specific narrative — persona scripts, marketing copy, and
 * long-form product story live in `companion/deployments/rainbow.js`.
 *
 * Rule of thumb: if a value would be identical across every Rainbow
 * boutique, it belongs here. If it describes Rainbow-the-culture
 * (Katrina's day, Damon's boutique), it belongs in the deployment
 * content layer instead.
 */
const totoProfile = {
  id: "toto",
  name: "Toto",
  displayName: "Toto",
  pronouns: "he/him",

  // Wordmark & short display strings the shell chrome reads.
  wordmark: "TOTO",
  productWordmark: "TOTO",
  productTagline: "a product of Rainbow Interests LLC",
  chatCta: "Ask SONMI",
  chatAriaLabel: "Chat with Toto",
  chatAssistantName: "Toto",
  searchPlaceholder: "Search TOTO…",

  // Presence — Toto inhabits SONMI's shared vessel as one possible occupant.
  iconMarkKey: "paw",       // "paw" | null — resolved by CompanionIconMark
  occupantKey: "toto-westie",
  avatarKey: "toto",        // key CompanionAvatar uses to pick an asset bundle
  toneKey: "warm-restrained",

  terminology: {
    guest: "guest",
    boutique: "boutique",
    team_member: "teammate",
  },

  capabilities: {
    animatedPresence: true,
    boutiqueTinting: true,
    iconMark: true,
    hasAssets: true,        // supports the "companion assets" admin page
  },
};

export default totoProfile;
